
import { controls } from '~/mixins/carousel'
import Slider from '~/components/Elements/Slider.vue'

const REVEAL_ANIMATION = {
  stagger: 'stagger',
  slider: 'slider',
}

export default {
  components: { Slider },
  mixins: [controls],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selector: null,
      gridItems: [],
      gridStyles: {
        'column-gap': this.blok.gap_x || '0px',
        'row-gap': this.blok.gap_y || '0px',
      },
      sliderItemStyles: {
        width: this.blok.slider_item_width,
        height: this.blok.slider_item_height,
      },
    }
  },
  computed: {
    gridColumn() {
      return {
        'items-center': this.blok?.center_items,
        // xl
        'xl:grid-cols-1': this.blok?.columns_xl === '1',
        'xl:grid-cols-2': this.blok?.columns_xl === '2',
        'xl:grid-cols-3': this.blok?.columns_xl === '3',
        'xl:grid-cols-4': this.blok?.columns_xl === '4',
        'xl:grid-cols-5': this.blok?.columns_xl === '5',
        'xl:grid-cols-6': this.blok?.columns_xl === '6',
        // lg
        'lg:grid-cols-1': this.blok?.columns_lg === '1',
        'lg:grid-cols-2': this.blok?.columns_lg === '2',
        'lg:grid-cols-3': this.blok?.columns_lg === '3',
        'lg:grid-cols-4': this.blok?.columns_lg === '4',
        'lg:grid-cols-5': this.blok?.columns_lg === '5',
        'lg:grid-cols-6': this.blok?.columns_lg === '6',
        // md
        'md:grid-cols-1': this.blok?.columns_md === '1',
        'md:grid-cols-2': this.blok?.columns_md === '2',
        'md:grid-cols-3': this.blok?.columns_md === '3',
        'md:grid-cols-4': this.blok?.columns_md === '4',
        'md:grid-cols-5': this.blok?.columns_md === '5',
        'md:grid-cols-6': this.blok?.columns_md === '6',
        // sm
        'sm:grid-cols-1': this.blok?.columns_sm === '1',
        'sm:grid-cols-2': this.blok?.columns_sm === '2',
        'sm:grid-cols-3': this.blok?.columns_sm === '3',
        'sm:grid-cols-4': this.blok?.columns_sm === '4',
        'sm:grid-cols-5': this.blok?.columns_sm === '5',
        'sm:grid-cols-6': this.blok?.columns_sm === '6',
        // xs
        'grid-cols-1': this.blok?.columns_xs === '1',
        'grid-cols-2': this.blok?.columns_xs === '2',
        'grid-cols-3': this.blok?.columns_xs === '3',
        'grid-cols-4': this.blok?.columns_xs === '4',
        'grid-cols-5': this.blok?.columns_xs === '5',
        'grid-cols-6': this.blok?.columns_xs === '6',
      }
    },
    setSlider() {
      return {
        'sm:hidden ': this.blok.mobile_slider === 'xs',
        'md:hidden': this.blok.mobile_slider === 'sm',
        'lg:hidden': this.blok.mobile_slider === 'md',
        'xl:hidden': this.blok.mobile_slider === 'lg',
        '2xl:blok': this.blok.mobile_slider === 'xl',
      }
    },
    setGrid() {
      let properties = null

      if (this.blok.inline_grid) {
        properties = {
          'inline-grid': !this.blok.mobile_slider,
          hidden: this.blok.mobile_slider === 'xs',
          ' hidden md:inline-grid': this.blok.mobile_slider === 'sm',
          ' hidden lg:inline-grid': this.blok.mobile_slider === 'md',
          ' hidden xl:inline-grid': this.blok.mobile_slider === 'lg',
          ' hidden ': this.blok.mobile_slider === 'xl',
        }
      } else {
        properties = {
          grid: !this.blok.mobile_slider,
          hidden: this.blok.mobile_slider === 'xs',
          ' hidden md:grid': this.blok.mobile_slider === 'sm',
          ' hidden lg:grid': this.blok.mobile_slider === 'md',
          ' hidden xl:grid': this.blok.mobile_slider === 'lg',
          ' hidden ': this.blok.mobile_slider === 'xl',
        }
      }

      return properties
    },
  },
  mounted() {
    this.selector = this.$gsap.utils.selector(this.$el)
    this.gridItems = this.$gsap.utils.toArray(this.selector('.grid__item'))

    this.$nextTick(() => {
      if (this.blok?.reveal_animation === REVEAL_ANIMATION.stagger) {
        this.staggerAnimate()
      }
      if (this.blok?.reveal_animation === REVEAL_ANIMATION.slider) {
        this.sliderAnimate()
      }
    })
  },
  methods: {
    staggerAnimate() {
      this.$gsap.utils.toArray(this.selector('.grid__item')).forEach((x) => {
        this.$gsap.set(x, { autoAlpha: 0, y: -50 })
      })

      this.$ScrollTrigger.batch(this.selector('.grid__item'), {
        // markers: true,
        start: 'top bottom-=80px',
        onEnter: (batch) =>
          this.$gsap.to(batch, {
            autoAlpha: 1,
            y: 0,
            stagger: 0.1,
            clearProps: 'scale',
          }),
        // once: true,
      })
    },
    sliderAnimate() {
      this.$gsap.context(() => {
        this.$gsap.set('.grid__item', {
          x: '100%',
          autoAlpha: 0,
        })
        this.$gsap.set(this.$refs.sliderContainer, {
          autoAlpha: 0,
          x: '15%',
        })

        this.$gsap
          .timeline({
            scrollTrigger: {
              trigger: this.$refs.gridContainer,
              start: 'top bottom',
              end: 'top top',
              // markers: true,
            },
          })
          .to('.grid__item', {
            x: 0,
            autoAlpha: 1,
            duration: 0.05,
            stagger: 0.1,
            ease: 'back(.5)',
          })
          .to(
            this.$refs.sliderContainer,
            {
              autoAlpha: 1,
              x: -20,
              duration: 0.05 * this.gridItems.length * 1.3,
              ease: 'elastic.out',
            },
            '<'
          )
          .to(this.$refs.sliderContainer, {
            x: 0,
            duration: 0.05 * this.gridItems.length * 1.3,
            onComplete: () => {
              this.$gsap.set('.grid__item', {
                clearProps: 'scale',
              })
            },
          })
      }, this.$refs.gridContainer)
    },
  },
}
